/**
 * Helpers for Figma "Tags" component set (node 375:4455).
 * Sage appears only as Filled (soft sage fill); Soft Sage only as Stroked.
 */

/**
 * @param {string} color
 * @param {string} variant
 */
export function normalizeTagsVariant(color, variant) {
  let c = color;
  let v = variant;
  if (c === "mint") c = "brandPrimary";
  if (c === "brand") c = "brandSecondary";
  if (c === "sage" && v === "stroked") {
    c = "softSage";
    v = "stroked";
  }
  if (c === "softSage" && v === "filled") {
    c = "sage";
    v = "filled";
  }
  return { color: c, variant: v };
}

export function tagsVariantKey(color, variant) {
  const { color: c, variant: v } = normalizeTagsVariant(color, variant);
  return `${c}${v === "filled" ? "Filled" : "Stroked"}`;
}
